export const displayLabelTablePagination = ({ from, to, count }) => {
  return `${from}–${to} from ${count !== -1 ? count : `more than ${to}`}`;
};

export const getSTT = (index) => {
  let stt = index + 1 < 10 ? `0${index + 1}` : <>{index + 1}</>;
  return stt;
};
